export default __webpack_public_path__ + "static/8971f91c5260a113a99a6675f3fc8307.png";